import { useEffect } from "react";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import { getPrimaryDomain } from "@/react/helpers/urlHelpers/currentDomain";
import { COUPON_CODE } from "@circle-react/components/OnboardingPage/helpers/constants";

export function useSetCouponCodeFromParamsToCookie() {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const couponCode = params.get("coupon_code");

    if (couponCode) {
      Cookies.set(COUPON_CODE, couponCode, {
        expires: 7,
        path: "/",
        domain: "." + getPrimaryDomain(window.location.hostname),
      });
    }
  }, [search]);
}
